import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useStore } from "../context/Store";
import { api } from "../lib/api";
import { AdminOrders } from "../components/admin/AdminOrders";
import { AdminProducts } from "../components/admin/AdminProducts";

const Stat = ({ label, value, id }) => (
  <div className="bg-white rounded-2xl p-5 border border-[#C85A32]/10" data-testid={`admin-stat-${id}`}>
    <p className="text-xs uppercase tracking-widest text-stone-500">{label}</p>
    <p className="font-display text-3xl font-extrabold mt-2">{value}</p>
  </div>
);

export default function Admin() {
  const { user, authChecked } = useStore();
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const loadStats = () => api.get("/admin/stats").then((r) => setStats(r.data));
  useEffect(() => {
    if (!authChecked) return;
    if (!user || user.role !== "admin") { nav("/login", { state: { next: "/admin" } }); return; }
    loadStats();
  }, [authChecked, user, nav]);
  if (!stats) return <div className="max-w-7xl mx-auto px-6 py-10"><div className="h-40 rounded-2xl bg-stone-200 animate-pulse" /></div>;
  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="admin-page">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold">Admin dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mt-8">
        <Stat id="revenue" label="Revenue (paid)" value={`$${stats.revenue_usd.toLocaleString()}`} />
        <Stat id="paid-orders" label="Paid orders" value={stats.paid_orders} />
        <Stat id="to-ship" label="To ship" value={stats.by_status.processing || 0} />
        <Stat id="products" label="Products" value={stats.products.toLocaleString()} />
        <Stat id="customers" label="Customers" value={stats.customers} />
      </div>
      <Tabs defaultValue="orders" className="mt-10">
        <TabsList>
          <TabsTrigger value="orders" data-testid="admin-tab-orders">Orders</TabsTrigger>
          <TabsTrigger value="products" data-testid="admin-tab-products">Products</TabsTrigger>
        </TabsList>
        <TabsContent value="orders"><AdminOrders onChange={loadStats} /></TabsContent>
        <TabsContent value="products"><AdminProducts onChange={loadStats} /></TabsContent>
      </Tabs>
    </div>
  );
}
